import React, { useEffect, useState } from "react";
import Map from "@/components/Map";
import api from "@/lib/api";
import { fetchShopsNearby } from "@/lib/adapt";
import { useT } from "@/lib/i18n";
import MenuButton from "@/components/mobile/MenuButton";

const DEFAULT_CENTER = { lat: 10.776, lng: 76.654 };

export default function MobileMap() {
  const { t } = useT();
  const [center] = useState(() => {
    try {
      const s = JSON.parse(localStorage.getItem("nd_center") || "null");
      return s?.lat ? { lat: s.lat, lng: s.lng } : DEFAULT_CENTER;
    } catch (_) {
      return DEFAULT_CENTER;
    }
  });
  const [shops, setShops] = useState([]);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {
    fetchShopsNearby(api, { lat: center.lat, lng: center.lng, radius: 50 })
      .then((list) => setShops(list))
      .catch(() => setShops([]));
  }, [center.lat, center.lng]);

  return (
    <div className="relative h-[calc(100vh-96px)]">
      <div className="absolute top-4 left-4 right-4 z-[500] flex items-center justify-between pointer-events-none">
        <span className="pointer-events-auto rounded-full bg-card border border-border px-4 py-2 font-semibold shadow">
          {t("tab.map")}
        </span>
        <span className="pointer-events-auto">
          <MenuButton />
        </span>
      </div>
      <Map center={center} shops={shops} activeId={activeId} onSelect={setActiveId} />
    </div>
  );
}
